import jsPDF from "jspdf";
import "./Css/InsuranceForm.css";
import html2canvas from "html2canvas";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import "./Css/PrintEqunry.css";
import { APL_LINK } from "../ServiceConnection/serviceconnection";
import Loader from "./Loader";

// ForwardRef to pass the ref from parent to child
const MVRDownload = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);

  const handlePrint = () => {
    window.print();
  };

  // console.log("MVRDownload props", props);
  const data = props.downloadForm;
  const DamageImg = props.DamageImg || []; // MVR images array - CHANGED THIS LINE
  // console.log("MVRDownload data", data);
  // console.log("MVRDownload DamageImg", DamageImg);

  const SignImg = props.SignImg;
  const DringImg = props.DringImg;

  // Function to load image and return as base64
  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve(img);
      img.onerror = (error) => {
        console.error("Image load error:", error);
        reject(error);
      };
      img.src = src;
    });
  };

  // Function to check if image is SVG
  const isSVG = (filename) => {
    return filename.toLowerCase().endsWith(".svg");
  };

  // Function to convert SVG to canvas
  const svgToCanvas = async (svgUrl) => {
    return new Promise((resolve, reject) => {
      fetch(svgUrl)
        .then((response) => response.text())
        .then((svgText) => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          const img = new Image();

          const blob = new Blob([svgText], { type: "image/svg+xml" });
          const url = URL.createObjectURL(blob);

          img.onload = () => {
            canvas.width = img.width || 800;
            canvas.height = img.height || 600;
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            resolve(canvas);
          };

          img.onerror = reject;
          img.src = url;
        })
        .catch(reject);
    });
  };

  const handleDownloadPDF = async () => {
    if (!data || Object.keys(data).length === 0) {
      console.warn("Data not ready yet.");
      return;
    }

    if (!DamageImg || DamageImg.length === 0) {
      alert("No MVR images found to download.");
      return;
    }

    setLoading(true);

    try {
      // Create PDF with compression options
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      let isFirstPage = true;
      let successCount = 0;

      // Loop through all MVR images
      for (let i = 0; i < DamageImg.length; i++) {
        const mvrItem = DamageImg[i];
        const imageName = mvrItem.image;
        const imageUrl = `${APL_LINK}assets/userlicence/${imageName}`;

        // console.log(`Loading image ${i + 1}/${DamageImg.length}:`, imageUrl);

        try {
          let canvas;

          // Check if image is SVG
          if (isSVG(imageName)) {
            // console.log("Processing SVG:", imageName);
            canvas = await svgToCanvas(imageUrl);
          } else {
            // Load regular image (JPEG, PNG, etc.)
            const img = await loadImage(imageUrl);

            // Create a canvas to draw the image
            canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");

            // Fill white background
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw image
            ctx.drawImage(img, 0, 0);
          }

          // Convert to base64
          const imgData = canvas.toDataURL("image/jpeg", 0.95);

          // Calculate dimensions to fit A4 page with proper aspect ratio
          const pageWidth = 190; // A4 width minus margins (210 - 20)
          const pageHeight = 277; // A4 height minus margins (297 - 20)

          let imgWidth = pageWidth;
          let imgHeight = (canvas.height * imgWidth) / canvas.width;

          // If image is too tall, scale based on height instead
          if (imgHeight > pageHeight) {
            imgHeight = pageHeight;
            imgWidth = (canvas.width * imgHeight) / canvas.height;
          }

          // Center the image
          const xOffset = (pageWidth - imgWidth) / 2 + 10;
          const yOffset = 10;

          // Add new page if not the first image
          if (!isFirstPage) {
            pdf.addPage();
          }

          // Add image to PDF
          pdf.addImage(imgData, "JPEG", xOffset, yOffset, imgWidth, imgHeight);

          // Add image information at the bottom
          pdf.setFontSize(10);
          pdf.setTextColor(100);
          pdf.text(
            `MVR Image ${i + 1} of ${DamageImg.length} | Diver Name: ${
              data?.first_name + " " + data?.last_name
            } | Car Number: ${data?.car_data[0]?.car_tagline}`,
            10,
            287
          );

          // Add filename
          pdf.setFontSize(8);
          pdf.text(`File: ${imageName}`, 10, 292);

          isFirstPage = false;
          successCount++;
        } catch (error) {
          console.error(`Error loading image ${imageName}:`, error);
          // Add a page with error message
          if (!isFirstPage) {
            pdf.addPage();
          }

          pdf.setFontSize(12);
          pdf.setTextColor(255, 0, 0);
          pdf.text(`Failed to load image: ${imageName}`, 10, 20);
          pdf.setFontSize(10);
          pdf.setTextColor(100);
          pdf.text(`Image ${i + 1} of ${DamageImg.length}`, 10, 287);

          isFirstPage = false;
        }
      }

      if (successCount === 0) {
        throw new Error("No images could be loaded successfully");
      }

      // Set PDF properties
      pdf.setProperties({
        title: "MVR Report",
        subject: "Motor Vehicle Report",
        creator: "Rapid Car Leasing",
        author: "System",
      });

      // Generate filename
      const fileName = `MVR_${data?.first_name || ""}_${
        data?.last_name || ""
      }_${data?.car_data?.[0]?.car_tagline || ""}_${new Date().getTime()}.pdf`;

      // Save PDF
      pdf.save(fileName.replace(/\s+/g, "_"));

      setLoading(false);

      if (successCount < DamageImg.length) {
        alert(
          `PDF generated with ${successCount} of ${DamageImg.length} images. Some images failed to load.`
        );
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Error generating PDF. Please try again.");
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    handleDownloadPDF: () => {
      if (!data || Object.keys(data).length === 0) {
        console.warn("Data not ready yet.");
        return;
      }
      handleDownloadPDF();
    },
    handlePrint,
  }));

  return (
    <div>
      {loading && <Loader />}

      <div
        id="pdf-content"
        className="insurance_contr"
        style={{ display: "none" }}
      >
        {/* Preview section (optional - hidden by default) */}
        <div className="part1" id="part1">
          <h3>MVR Images Preview</h3>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {DamageImg && DamageImg.length > 0 ? (
              DamageImg.map((mvrItem, index) => (
                <div
                  key={mvrItem.primary_id || index}
                  style={{ textAlign: "center" }}
                >
                  <img
                    src={`${APL_LINK}assets/userlicence/${mvrItem.image}`}
                    alt={`MVR ${index + 1}`}
                    style={{
                      width: "150px",
                      height: "auto",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                    }}
                  />
                  <p style={{ fontSize: "10px", margin: "5px 0" }}>
                    Name: {data?.first_name + " " + data?.last_name} | Car:{" "}
                    {data?.car_data[0]?.car_tagline}
                  </p>
                </div>
              ))
            ) : (
              <p>No MVR images available</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default MVRDownload;
